import { render, staticRenderFns } from "./CompanyAdress.vue?vue&type=template&id=1b48aa1a&"
import script from "./CompanyAdress.vue?vue&type=script&lang=js&"
export * from "./CompanyAdress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports